import { Link } from "react-router-dom";
import { NAV_LINKS, CONTACT, waLink } from "@/data/site";
import Wordmark from "@/components/Wordmark";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="relative z-10 bg-plum text-ivory">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-20 md:py-24">
        <div className="grid gap-14 md:grid-cols-3 md:gap-10">
          {/* Marca */}
          <div>
            <Wordmark tone="ivory" />
            <p className="mt-6 max-w-xs font-sans font-light text-sm leading-relaxed text-ivory/70">
              Estudio creativo dedicado a diseñar experiencias que emocionan, conectan y perduran.
            </p>
          </div>

          {/* Navegación */}
          <div className="md:justify-self-center">
            <p className="mb-6 text-xs uppercase tracking-[0.25em] text-rosegold">Navegación</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.to === "/" ? "inicio" : link.to.replace("/", "")}`}
                    className="font-sans font-light text-ivory/80 transition-colors duration-300 hover:text-rosegold"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto / redes */}
          <div className="md:justify-self-end">
            <p className="mb-6 text-xs uppercase tracking-[0.25em] text-rosegold">Conecta</p>
            <a
              href={waLink("Hola Lu Design, me gustaría conocer más sobre sus servicios.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="block font-sans font-light text-ivory/80 transition-colors duration-300 hover:text-rosegold"
            >
              WhatsApp · {CONTACT.whatsappDisplay}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              className="mt-3 block font-sans font-light text-ivory/80 transition-colors duration-300 hover:text-rosegold"
            >
              {CONTACT.email}
            </a>

            <div className="mt-8 flex gap-4">
              {CONTACT.socials.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/25 text-ivory/80 transition-[background-color,color,border-color] duration-500 hover:border-rosegold hover:bg-rosegold hover:text-ivory"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-ivory/15 pt-10 text-center">
          <p className="font-serif italic text-xl md:text-2xl text-ivory/90">
            Gracias por permitirnos ser parte de tu historia.
          </p>
          <p className="mt-6 text-xs uppercase tracking-[0.2em] text-ivory/40">
            © {new Date().getFullYear()} Lu Design · Diseño que conecta e inspira
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
